export default __webpack_public_path__ + "static/media/sparkling1.c9a4bd0f.jpg";